export const SDK_VERSION = '7.82.0';
